import { useState, useEffect } from 'react';
import { attendanceService } from 'services/api';
import InfoModal from './InfoModal';
import styles from './RepresentacionesModal.module.css';

export default function RepresentacionesModal({ assembly, onClose }) {
  const [units,   setUnits]   = useState(null); // null = cargando
  const [error,   setError]   = useState('');

  useEffect(() => {
    attendanceService.myRepresentations(assembly.id)
      .then(r => setUnits(r.data.units || []))
      .catch(err => setError(
        err.response?.status === 404
          ? 'Función no disponible — actualiza el servidor (falta la migración de la Ola 0).'
          : (err.response?.data?.message || 'No se pudieron cargar las representaciones.')
      ));
  }, [assembly.id]);

  return (
    <InfoModal title="Representaciones" icon="fa-users" color="#0ea5e9" onClose={onClose}>
      <p className={styles.intro}>
        Unidades que representas por poder en la asamblea
        <strong> {assembly.property?.name} #{assembly.number_assembly}</strong>.
      </p>
      {units === null && !error ? (
        <div className={styles.cargando}><div className={`spinner ${styles.spinnerChico}`} /></div>
      ) : error ? (
        <div className={styles.error}>{error}</div>
      ) : units.length === 0 ? (
        <div className={styles.vacio}>
          <i className={`fas fa-info-circle ${styles.iconoAzul}`} />
          No tienes representaciones activas en esta asamblea.
        </div>
      ) : (
        <div className={styles.lista}>
          {units.map((u, i) => (
            <div key={i} className={styles.unidad}>
              <div className={styles.unidadTitulo}>
                Unidad {u.unit}{u.torre ? ` · ${u.torre}` : ''}
              </div>
              <div className={styles.unidadDetalle}>
                {u.owner || '—'}{u.owner_doc ? ` · ${u.owner_doc}` : ''}
                {u.coeficiente != null ? ` · coef. ${u.coeficiente}` : ''}
              </div>
            </div>
          ))}
          <div className={styles.resumen}>
            {units.length} unidad{units.length !== 1 ? 'es' : ''} — tu voto en cada pregunta se aplica a todas.
          </div>
        </div>
      )}
    </InfoModal>
  );
}
